class DiameterSelector extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.inputs = this.querySelectorAll('input[type="radio"]');

    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const form = document.getElementById(this.formId);
        if (form) {
          form.dispatchEvent(new Event('change', { bubbles: true }));
          form.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }
}

if (!customElements.get('diameter-selector')) {
  customElements.define('diameter-selector', DiameterSelector);
}